import { render } from "./DemoBanner.vue?vue&type=template&id=7a274f8d&scoped=true"
import script from "./DemoBanner.vue?vue&type=script&lang=js"
export * from "./DemoBanner.vue?vue&type=script&lang=js"

import "./DemoBanner.vue?vue&type=style&index=0&id=7a274f8d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a274f8d"]])

export default __exports__